<template>
  <div>
    <section
      id="welcome"
      v-resize="onResize"
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
          md6
          lg8
        >
          <v-img
            :src="require('@/assets/nav-patient.png')"
            height="100vh"
          >
            <!-- <v-img
          :src="require('@/assets/nav-patient.png')"
          :height="mobile ? '70vh' : '100vh'"
        > -->
            <div
              v-if="!mobile"
              class="fill-height bottom-gradient"
            >
            </div>
            <v-layout
              v-if="mobile"
              pb-1
              column
              fill-height
              class="lightbox white--text"
              align-center
            >
              <v-spacer></v-spacer>
              <v-flex>
                <h1 class="white--text display-4 text-xs-center font-weight-regular font-italic text-uppercase">Simoni</h1>
                <h3 class="white--text display-2 text-xs-center">Plastic Surgery</h3>
                <base-btn class="mt-4">
                  Learn More!
                </base-btn>
              </v-flex>
            </v-layout>
          </v-img>
        </v-flex>
        <v-flex
          xs12
          md6
          lg4
          align-content-space-between
          layout
          :pa-5="$vuetify.breakpoint.smAndDown"
          wrap
        >
          <base-bubble-1 style="transform: rotate(180deg) translateY(25%)" />

          <v-layout
            align-center
            justify-center
          >
            <v-flex
              xs10
              md6
            >
              <base-heading class="primary--text">Facial Plastic Surgeon</base-heading>
              <base-text>
                Your road to a beautiful nose<br>
                <ul>
                  <li>No Nose Breaking</li>
                  <li>No Packing</li>
                  <li>Stunning Results</li>
                  <li>Minimal Downtime</li>
                  <li>No Pain</li>
                </ul>

              </base-text>
              <base-btn class="mt-4">
                Learn More!
              </base-btn>
            </v-flex>
          </v-layout>

          <base-bubble-2 style="transform: rotate(180deg) translate(-200px, -15%)" />
        </v-flex>
      </v-layout>
    </section>
    <section>
      <v-layout>
        <v-flex>
          <v-img
            :src="require('@/assets/grey-media.jpg')"
            height="100%"
          />
        </v-flex>
      </v-layout>
    </section>
    <!-- <section
    id="services"
    class="hide-overflow"
  >
<v-container>
        <v-layout
          justify-center
          row
          wrap

        >
          <v-flex
            v-for="(service, i) in services"
            :key="i"
            xs12
            sm6
            md4
            ma-2
          >
            <v-card height="100%">
              <v-img
                :src="require('@/assets/' + service.image)"
                aspect-ratio="1.5"
              ></v-img>
              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0">{{service.title}}</h3>
                  <br>
                  <p>{{service.text}}</p>
                  <p v-if="service.signature">{{service.signature}}</p>
                </div>
              </v-card-title>
              <v-card-actions>
                <v-btn
                  flat
                  color="primary"
                >Read More</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        </v-container>
  </section> -->
    <section id="media">
      <v-container grid-list-md>
        <v-layout
          row
          wrap
        >
          <v-flex
            v-for="(item, i) in media"
            :key="i"
            xs12
            sm6
            md4
          >
            <v-card
              flat
              hover
              height="100%"
              to="#"
            >
              <v-img
                :src="require('@/assets/' + item.image)"
                aspect-ratio="1.5"
              ></v-img>
              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0">{{item.title}}</h3>
                  <br>
                  <p>{{item.text}}</p>
                  <p v-if="item.signature">{{item.signature}}</p>
                </div>
              </v-card-title>
              <!--  <v-card-actions>
                  <v-btn
                    flat
                    color="primary"
                  >Read More</v-btn>
                </v-card-actions> -->
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section
      id="services"
      class="services-home"
    >
      <v-carousel
        hide-delimiters
        light
      >
        <v-carousel-item
          v-for="(service, i) in services"
          :key='i'
        >
          <v-layout
            align-center
            justify-center
            row
            fill-height
          >
            <v-flex
              sm6
              class="hidden-xs-and-down"
            >
              <v-img :src="require('@/assets/' + service.image)"></v-img>
            </v-flex>
            <v-flex
              sm6
              pa-3
            >
              <!--   <h1 class="primary--text">{{service.title}}</h1> -->
              <base-heading class="primary--text">{{service.title}}</base-heading>
              <h2 v-if="service.subtitle">{{service.subtitle}}</h2>
              <p>{{service.text}}</p>
              <v-btn
                class="primary"
                :to="{ name: service.link}"
              >Learn More</v-btn>
            </v-flex>
          </v-layout>
        </v-carousel-item>
      </v-carousel>
    </section>

    <section class="welcome-gallery">
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
          md6
          lg4
          align-content-space-between
          layout
          :pa-5="$vuetify.breakpoint.smAndDown"
          wrap
        >

          <v-layout
            align-center
            justify-center
            v-if="!mobile"
          >
            <v-flex
              xs10
              md6
            >
            <div style="padding-top: 160px;padding-bottom: 160px;">
              <base-heading class="primary--text">Gallery</base-heading>
              <base-text>
              </base-text>
              <base-btn class="mt-4">
                Explore
              </base-btn>
              </div>
            </v-flex>
          </v-layout>
          <v-layout
            align-center
            justify-left
             v-if="mobile"
          >
            <v-flex
              xs10
              md6
            >
            <div style="padding-top: 75px;padding-bottom: 75px;">
              <base-heading class="primary--text">Gallery</base-heading>
              <base-text>
              </base-text>
              <base-btn class="mt-4">
                Explore
              </base-btn>
              </div>
            </v-flex>
          </v-layout>

        </v-flex>
        <!-- <v-flex
          xs12
          md6
          lg8
        >
          <v-img
            :src="require('@/assets/nav-girl-3.png')"
            height="100vh"
          >
            <div
              v-if="!mobile"
              class="fill-height bottom-gradient"
            >
            </div>
            <v-layout
              v-if="mobile"
              pb-1
              column
              fill-height
              class="lightbox white--text"
              align-center
            >
              <v-spacer></v-spacer>
              <v-flex>
                <h1 class="white--text display-3 text-xs-center font-weight-regular font-italic text-uppercase">Gallery</h1>
                <base-btn class="mt-4">
                  Explore
                </base-btn>
              </v-flex>
            </v-layout>
          </v-img>
        </v-flex> -->
      </v-layout>
    </section>

    <section id="about">
      <v-layout white>
        <v-flex
          xs12
          md6
          pa-5
        >
          <base-bubble-1 style="transform: translate(5%, -5%)" />
          <base-heading class="info--text">
            About Dr. Payman Simoni
          </base-heading>

          <base-text class="mb-5">
            When other doctors decide to undergo cosmetic surgery and are looking for a plastic surgeon, Dr. Payman Simoni is the plastic surgeon they choose. His background in cosmetic facelifts, rhinoplasty and reputation for natural results makes him one of the most sought after facial cosmetic surgeons.
          </base-text>
          <base-text class="mb-5">
            Dr. Payman Simoni is the double board certified facial plastics expert who has perfected advanced rhinoplasty techniques and an anesthesia-free solution to facial rejuvenation, resulting in minimal risk, rapid recovery, and superior results.
          </base-text>
          <base-btn class="mt-4">
            Learn More!
          </base-btn>

        </v-flex>
        <v-flex
          hidden-sm-and-down
          md6
        >
          <v-img
            :src="require('@/assets/about-image-1.jpg')"
            height="100%"
          />
        </v-flex>
      </v-layout>
    </section>
  </div>
</template>
<script>
export default {
  /*  components: {

    ServicesCarousel: () => import('@/components/ServicesCarousel')
  }, */
  data: () => ({
    flat: true,
    mobile: false,
    media: [
      {
        title: 'Patient Stories',
        text: 'The reviews and stories on these pages illustrate Dr. Simoni’s patients’ experiences. However it is important to note that in plastic Surgery results may vary. The outcome of any plastic surgery procedure depends on the particulars of each patient’s individual case. In providing the  statements on this web site does not state or imply any guarantee. Read the testimonials below.',
        signature: '- Payman Simoni, Md',
        image: 'feat-patient-stories.jpg'
      },
      {
        title: 'Before & After Photo Gallery',
        text: 'It is essential to view a cosmetic surgeon’s gallery of before and after photos so you can get a much better idea of their results. No amount of words on a page can demonstrate his skill better than a before & after gallery. Review Dr. Simoni’s work here to see the spectacular results he has achieved with patient after patient.',
        signature: '',
        image: 'feat-gallery-1.jpg'
      },
      {
        title: 'Dr. Simoni in the Media',
        text: 'He has been featured in numerous top tv shows, including Entertainment Tonight and The View, and more for his unique views on cosmetic facial surgery and minimally invasive procedures using local anesthetic.',
        signature: '',
        image: 'feat-media.jpg'
      }
    ],
    services: [
      {
        title: 'Rhinoplasty',
        text: 'No other procedure can make such a dramatic difference to one’s appearance through subtle changes that enhance the other facial features. Dr. Payman Simoni is an acclaimed double board certified facial plastic surgeon with thousands of successful rhinoplasty procedures to his credit.',
        image: 'bkg-rhino-girl.png',
        link: 'Rhinoplasty'
      },
      {
        title: 'Simoni Facelift',
        subtitle: 'Less Downtime — Outstanding Natural Results',
        text: 'Whether considering a full surgical facelift, or the revolutionary one hour Simoni Facelift, a key component of acquiring the best facelift Beverly Hills can provide is to trust the procedure only to a board certified facial specialist. This ensures your surgeon has the skill and command over the delicate techniques needed to produce stunning natural results.',
        image: 'bkg-facelift-girl.png',
        link: 'Facelift'
      },
      {
        title: 'Tumescent Liposuction',
        text: 'Tumescent liposuction, also known as tumescent liposculpture, is internationally recognized as the safest liposuction technique with the fastest recovery time, the best aesthetic results and the least pain.',
        image: 'body-1.jpg',
        link: 'Liposuction'
      }
    ]
  }),
  methods: {
    onResize () {
      this.mobile = window.innerWidth < 960
    }
  }
}
</script>
<style scoped>
.bottom-gradient {
  background-image: linear-gradient(
    to top,
    transparent,
    transparent,
    transparent,
    rgba(255, 255, 255, 0.9)
  );
}
.services-home {
  background: url('../assets/boxes-shadow.png') repeat-x,
    url('../assets/bg-grey-scratch.png') repeat;
}
.welcome-gallery {
  background-image: url('../assets/nav-girl-3.png');
  background-repeat: no-repeat;
  background-position: right;
}

</style>
